import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Dimensions, Platform } from 'react-native';
import { useBanners } from '../../../BannerManager';
import BannerCarousel from './BannerCarousel';
import PlatformDetector from '../../../../utils/PlatformDetector';

/**
 * Componente padre que contiene los dos banners duales (izquierdo y derecho)
 * Se adapta proporcionalmente al tamaño de la pantalla
 */
const BannersDuales = () => {
  const { banners: allBanners, loading } = useBanners();
  
  // Estado para detectar vista móvil
  const [isMobileView, setIsMobileView] = useState(
    PlatformDetector.isMobile() || (PlatformDetector.isWeb() && Dimensions.get('window').width < 768)
  );

  // Efecto para manejar cambios de tamaño de ventana
  useEffect(() => {
    if (PlatformDetector.isWeb()) {
      const handleResize = () => {
        const { width } = Dimensions.get('window');
        setIsMobileView(width < 768);
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  // Obtener los banners de las filas 4 y 5
  const leftBanners = allBanners.fila4 || [];
  const rightBanners = allBanners.fila5 || [];

  // Verificar si debemos mostrar los componentes
  const hasLeftBanners = leftBanners.some(b => !!b.imagenWeb) || loading;
  const hasRightBanners = rightBanners.some(b => !!b.imagenWeb) || loading;

  // Si no hay banners en ninguna fila, no renderizar nada
  if (!hasLeftBanners && !hasRightBanners) {
    return null;
  }

  return (
    <View style={[styles.container, isMobileView && styles.containerMobile]}>
      {/* Banner Izquierdo */}
      {hasLeftBanners && (
        <View style={[styles.bannerWrapper, isMobileView && styles.bannerWrapperMobile]}>
          <BannerCarousel
            banners={leftBanners}
            loading={loading}
            position="left"
            isMobileView={isMobileView}
          />
        </View>
      )}

      {/* Banner Derecho */}
      {hasRightBanners && (
        <View style={[styles.bannerWrapper, isMobileView && styles.bannerWrapperMobile]}>
          <BannerCarousel
            banners={rightBanners}
            loading={loading}
            position="right"
            isMobileView={isMobileView}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginBottom: 40,
    marginTop: 40,
    gap: '2%',
  },
  containerMobile: {
    width: '100%',
    marginHorizontal: 0,
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 20,
    marginTop: 20,
    gap: 10,
  },
  bannerWrapper: {
    width: '49%',
    minWidth: 280,
  },
  bannerWrapperMobile: {
    width: '100%',
    maxWidth: '100%',
    flex: undefined,
  },
});

export default BannersDuales;
